export enum CurrencySymbol {
    AED = 'د.إ',
    AUD = '$',
    EUR = '€',
    GBP = '£',
    SGD = '$',
    USD = '$',
    INR = '₹'
}
